import React from 'react';
import * as Types from 'pages/Features/typings';
import { Fields } from 'types/FormValue';
import FilterLayout from './FilterLayout';
import Export from './Export';
import GroupMessaging from './GroupMessaging/GroupMessaging';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  values: Types.FeatureValues;
  errors: any;
  userStatus: number;
  fields: Fields;
}

function Directory({ setFieldValue, values, errors, userStatus, fields }: Props) {
  return (
    <>
      <FilterLayout
        onChange={setFieldValue}
        userStatus={userStatus}
        fields={Object.values(fields)}
        values={values}
      />
      <Export
        onChange={setFieldValue}
        value={values.client.settings.export}
        errorMessage={errors.export}
      />
      <GroupMessaging setFieldValue={setFieldValue} values={values} />
    </>
  );
}

export default Directory;
